"use strict";

exports.__esModule = true;
exports.DevicePlansContext = void 0;
var _DevicePlansController = require("./DevicePlansController");
var _Utils = require("../../Utils");
var DevicePlansContext = exports.DevicePlansContext = (0, _Utils.createEnhancedContext)({
  propName: "devicePlans",
  defaultController: _DevicePlansController.DevicePlansController
});